import React from "react";
import { ScreenComponent, ScreenProps } from "../types";
import BattleEntry from "./BattleEntry";
import "./index.css";
import BatttleEndTurn from "./BattleEndTurn";

const BattleScreen: ScreenComponent = (props: ScreenProps) => {
  const { state, dispatch } = props;
  const onClick = () => {
    dispatch({ type: "changeTurn" });
  };

  return (
    <div id="battle-screen">
      {state.actors.map((actor, index) => (
        <BattleEntry
          key={actor.id}
          gambitProps={{
            gambitData: actor.gambits,
            index,
            dispatch,
            editable: state.turn.battle === 0
          }}
          frameProps={{ name: actor.frame.name, lastAction: actor.lastAction }}
          infoProps={{ stats: actor.stats, statuses: actor.statuses }}
        />
      ))}
      <BatttleEndTurn onClick={onClick} turn={state.turn} />
    </div>
  );
};

export default BattleScreen;
